<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.product.import') }}
      </h1>

      <div
        v-if="!isProcessing"
        class="card rounded-0 mb-4"
      >
        <form class="card-body">
          <div
            v-if="!products.length"
            class="row mb-2"
          >
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3 justify-content-end me-auto ms-auto text-center">
              <input
                id="fileUpload"
                ref="fileUpload"
                type="file"
                accept=".xlsx"
                hidden
                @change="onFileChange"
              >
              <label class="control-label fw-bold mb-1">
                {{ $t('label.product.importFolder') }}
              </label>
              <button
                class="btn btn-primary rounded-pill font-custom text-uppercase font-inverted me-2 form-control btn-import"
                type="button"
                @click="chooseFile()"
              >
                <i class="fa fa-upload me-1" />
                {{ $t('button.chooseFile') }}
              </button>
            </div>
          </div>

          <div
            v-if="products.length"
            class="row mb-2"
          >
            <div class="col justify-content-end text-center criteria-button">
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted me-2 "
                type="button"
                @click="createProducts()"
              >
                <i class="fa fa-save me-1" />
                Créer les produits sélectionnés
              </button>

              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom "
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>
      <div v-else-if="products.length">
        <div class="table-responsive">
          <table
            class="table table-hover table-sm table-striped border"
            style="white-space:nowrap;"
          >
            <thead>
              <tr>
                <th>
                  <input
                    v-model="allSelected"
                    type="checkbox"
                    @click="selectAll()"
                  >
                </th>
                <th>{{ $t('label.product.reference') }}</th>
                <th>{{ $t('label.product.name') }}</th>
                <th>{{ $t('label.product.distributorRef') }}</th>
                <!-- th >{{ $t('label.product.status') }}</th-->
                <!--th>{{ $t('label.product.activationDate') }}</th>
                <th>{{ $t('label.product.deactivationDate') }}</th-->
                <!--th>{{ $t('label.actions') }}</th-->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="product in products"
                :key="product.id"
                class="mb-3"
              >
                <td>
                  <input
                    id="product.params.prb1"
                    v-model="checkedProducts"
                    type="checkbox"
                    :value="product.params.prb1"
                  >
                </td>
                <td>{{ product.params.prb1 }}</td>
                <td>{{ product.params.prb3 }}</td>
                <td>{{ product.params.prb7 }}</td>
                <!-- td>{{ product.productStatus }}</td >
                <td>{{ $filters.dateYYYYMMDDTirets(product['PRB-4']) }}</td>
                <td>{{ $filters.dateYYYYMMDDTirets(product['PRB-6']) }}</td-->
                <!-- td>
                    <BaseButton type="button" class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom" dataToggle="modal" dataTarget="detailModal" @click-base-button-event-emitter="showDetails(product)">
                      {{ $t('button.detail') }}
                    </BaseButton>
                </td-->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>

    <!-- The Detail Modal -->
    <div
      id="detailModal"
      class="modal"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('title.product.detail') }}
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <table class="table table-hover table-sm table-striped border">
              <thead class="font-custom">
                <tr>
                  <th>Paramètre</th>
                  <th>Valeur</th>
                  <!-- th>Actions</th -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, key) in currentProduct"
                  :key="key"
                  class="mb-3"
                >
                  <td>{{ key }}</td>
                  <td>{{ item }}</td>
                  <!-- td></td -->
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              {{ $t('label.product.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <SuccessDialog ref="successDialogRef" />
    <ErrorDialog ref="errorDialogRef" />
    <goTopButton />
    <goBottomButton />
  </div>
</template>

<script src="./ProductImport.js"></script>

<style src="./ProductImport.scss" scoped lang="scss"></style>
